import { companyApiRoute } from '@crm/shared/api'

import type { TDeal } from '@crm/entities/deal'

export const projectApiRoutes = {
  createProject: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}/project`),
}
